export enum UploadingStage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PROGRESS,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PROCESSING,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  INTENTION,
}
